// extracted by mini-css-extract-plugin
export default {"title":"CardsLimitReached_title__slBiF","img":"CardsLimitReached_img__GUaFo","paragraph":"CardsLimitReached_paragraph__FV0x-","button":"CardsLimitReached_button__UZg6T"};